import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import * as moment from 'moment';
import {
  IconButton,
  BankingExportTotalsTable,
  PaymentTable,
  RouteWrapper,
  HeadingSection,
  Section,
} from '../../components';
import {
  getBankingExport,
  getBankingExportCsv,
  getBankingExportTotals,
} from '../../redux/actions/payments';

interface Props {
  dispatch: Function;
  match: any;
}

interface State {
  id: number;
  errorMessage: string | boolean;
  isReady: boolean;
  bankingExport?: any;
  bankingExportTotals?: any;
}

class Route extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.match.params.id,
      errorMessage: false,
      isReady: false,
    };
  }

  /**
   * Retrieve the banking export
   */
  async componentDidMount() {
    const response = await this.props.dispatch(getBankingExport(this.state.id));
    if (!response.error) {
      this.setState({ bankingExport: response.data });
    } else {
      this.setState({ errorMessage: response.error });
    }
    const totalsResponse = await this.props.dispatch(
      getBankingExportTotals(this.state.id),
    );
    if (!totalsResponse.error) {
      this.setState({
        bankingExportTotals: totalsResponse.data,
        isReady: true,
      });
    } else {
      this.setState({ errorMessage: totalsResponse.error });
    }
  }

  render() {
    let start;
    let end;
    if (this.state.bankingExport) {
      start = moment(this.state.bankingExport.start);
      end = moment(this.state.bankingExport.end);
    }
    return (
      <RouteWrapper
        title={`Banking Export #${this.state.id}`}
        requireAuth
        ready={this.state.isReady}
        requirePermission="MANAGE_PAYMENTS"
        error={this.state.errorMessage}
        breadcrumbs={[
          {
            link: '/payments/banking-export',
            text: 'Banking Exports',
          },
          {
            link: `/payments/banking-export/${this.state.id}`,
            text: `Banking Export #${this.state.id}`,
          },
        ]}
      >
        <HeadingSection
          title={
            this.state.bankingExport &&
            `${start.calendar()} - ${end.calendar()} (£${
              (this.state.bankingExportTotals || { total: 0 }).total
            })`
          }
          controls={[
            <IconButton
              key="back-button"
              icon="download"
              className="is-default"
              handleClick={async (target) => {
                const response = await this.props.dispatch(
                  getBankingExportCsv(this.state.id),
                );
                if (!response.error) {
                  // Store the data in an anchor tag and then 'click' the tag to download the file
                  const data = `data:text/plain;charset=utf-8,${encodeURIComponent(
                    response.data,
                  )}`;
                  const a: HTMLAnchorElement = document.createElement('a');
                  a.setAttribute('href', data);
                  a.setAttribute(
                    'download',
                    `banking-export-${this.state.id}.csv`,
                  );
                  document.querySelector('body').appendChild(a);
                  a.click();
                  document.querySelector('body').removeChild(a);
                }
              }}
            >
              Export
            </IconButton>,
            <IconButton
              key="back-button"
              icon="undo"
              className="is-default"
              handleClick={() => {
                this.props.dispatch(goBack());
              }}
            >
              Return
            </IconButton>,
          ]}
        />
        <Section>
          <BankingExportTotalsTable totals={this.state.bankingExportTotals} />
          <br />
          <PaymentTable isArchived={true} bankingExportId={this.state.id} />
        </Section>
      </RouteWrapper>
    );
  }
}

export default connect()(Route);
